// Keys used for entries in local storage
export const StorageKey = {
  BHB_RETURN_PARAMS: "@bp:bhb",
  BHB_WIZARD_MODEL: "@bp:booking",
  CORRELATION_ID: "@bp:correlation-id"
};
